import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: ${({ color }) =>
    color === 'black' || color === 'petrol' ? `var(--color-text-light)` : `var(--color-text-dark)`};
  background: ${({ color }) => (color ? `var(--color-${color})` : `var(--color-secondary)`)};
  appearance: none;
  border: none;
  box-shadow: none;
  border-radius: var(--border-radius-default) 0;
  outline: none;
  cursor: pointer;
  transition: all var(--transition-default);
  padding: 1.8rem 4rem 1.7rem 4rem;
  margin: 0;

  &:hover {
    background: var(--color-black);
    color: var(--color-secondary);
  }

  ${({ size }) =>
    size === 'half' &&
    `
    border-radius: 0;
    padding-right: 3rem;
    padding-left: 3rem;

    &:first-of-type {
      border-top-left-radius: var(--border-radius-default);
    }

    + button {
      border-bottom-right-radius: var(--border-radius-default);
    }
  `}

  @media (${({ theme }) => theme.respondTo.tablet}) {
    ${({ size }) =>
      size === 'large' &&
      `
      padding: 2.2rem 5rem 2.1rem;
    `}

    ${({ size }) =>
      size === 'extraLarge' &&
      `
      font-size: var(--font-size-md);
      padding: 2.3rem 5rem 2.2rem;
    `}
  }
`;

const Button = ({ color, half, large, children, ...rest }) => (
  <StyledButton color={color} half={half} large={large} {...rest}>
    {children}
  </StyledButton>
);

export default Button;
